import type { AysClinicMedicalCareLevel } from '@bindoc-projects/clinic-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';

export const AYS_CLINIC_MEDICAL_CARE_LEVEL_CONDITION_ID = 'medicalCareLevel';
export const FilterConditionClinicMedicalCareLevelPluginType: FilterConditionPluginSpecification<
  AysClinicMedicalCareLevel[],
  FilterConditionClinicMedicalCareLevelDto,
  AysClinicMedicalCareLevelCondition
> = {
  type: 'medicalCareLevels',
  category: 'clinic',
  displayName: { de: 'Versorgungsstufe' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionClinicMedicalCareLevelDto,
  ): FilterConditionPluginImpl<AysClinicMedicalCareLevel[]> {
    return new FilterConditionClinicMedicalCareLevelPlugin(
        obj.medicalCareLevels as AysClinicMedicalCareLevel[],
      );
  },
  fromCondition(
    jsonObj: AysClinicMedicalCareLevelCondition,
  ): FilterConditionPluginImpl<AysClinicMedicalCareLevel[]> {
    return new FilterConditionClinicMedicalCareLevelPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AysClinicMedicalCareLevel[]> {
    return new FilterConditionClinicMedicalCareLevelPlugin([]);
  },
};

export class FilterConditionClinicMedicalCareLevelPlugin extends FilterConditionPluginImpl<
  AysClinicMedicalCareLevel[],
  FilterConditionClinicMedicalCareLevelDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysClinicMedicalCareLevel[],
    FilterConditionClinicMedicalCareLevelDto,
    AysClinicMedicalCareLevelCondition
  > = FilterConditionClinicMedicalCareLevelPluginType;

  constructor(private medicalCareLevels: AysClinicMedicalCareLevel[]) {
    super(FilterConditionClinicMedicalCareLevelPluginType.type);
  }

  clone(): FilterConditionClinicMedicalCareLevelPlugin {
    return new FilterConditionClinicMedicalCareLevelPlugin([
      ...this.medicalCareLevels,
    ]);
  }

  override equals(other: FilterConditionClinicMedicalCareLevelPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.medicalCareLevels, other.medicalCareLevels)
    );
  }

  override validationToText(): string {
    if (this.medicalCareLevels.length === 0) {
      return 'Mindestens eine Versorgungsstufe auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AysClinicMedicalCareLevelCondition(this.medicalCareLevels, []);
  }

  toJSON(): FilterConditionClinicMedicalCareLevelDto | null {
    return {
      type: this.type,
      medicalCareLevels: this.medicalCareLevels,
    };
  }

  toText(): string | null {
    return this.medicalCareLevels.length === 1
      ? 'eine Versorgungsstufe'
      : `${this.medicalCareLevels.length} Versorgungsstufen`;
  }

  toValue(): AysClinicMedicalCareLevel[] {
    return this.medicalCareLevels;
  }
}

export class AysClinicMedicalCareLevelCondition extends BdContentCondition<AysClinicMedicalCareLevel> {
  constructor(
    includes: AysClinicMedicalCareLevel[],
    excludes: AysClinicMedicalCareLevel[],
  ) {
    super(AYS_CLINIC_MEDICAL_CARE_LEVEL_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionClinicMedicalCareLevelDto {
  type: string;
  medicalCareLevels: string[];
}
